import defineCustomElement from './defineCustomElement.bea6.js'
import cartGlobalStore from './cartGlobalStore.4268.js'
import views from './views.cdcf.js'

// Prevent dragging of elements by default. There's CSS for <a> and <img />
// in chrome but this is to fix all other browsers like FF.
// -- add a teardown if ever porting this code
document.documentElement.addEventListener('dragstart', (e) => e.preventDefault())

// allows :active css state to work in iOS, which allows us to create tap-able buttons styles
// see: https://stackoverflow.com/questions/18047353/fix-css-hover-on-iphone-ipad-ipod
document.documentElement.addEventListener('touchend', () => {})


defineCustomElement('md-img', (el) => {
  const img = el.querySelector('img')
  if(img.naturalWidth || img.naturalHeight) return // already loaded (same as img.complete ?)
  img.style.opacity = 0
  img.classList.add('transition-opacity')
  img.classList.add('duration-[.2s]')
  const onLoad = () => {
    img.style.opacity = 1
    img.removeEventListener('load', onLoad)
  }
  // on error, remains hidden
  img.addEventListener('load', onLoad)
})

// ProductCard
defineCustomElement('md-product-card-cart', (el) => {
  const id = el.dataset.variantId

  const add = () => fetch('/cart/add.js', {
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      items: [{
        id: id,
        //quantity: 1
      }]
    })
  }).finally(() => {
    cartGlobalStore.refresh()
    views.toggleCart(true)
  })

  el.addEventListener('click', (e) => {
    e.preventDefault()
    add()
  })
})
